import { render, staticRenderFns } from "./GitLabMD.vue?vue&type=template&id=6c78c1e6&scoped=true"
import script from "./GitLabMD.vue?vue&type=script&lang=js"
export * from "./GitLabMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78c1e6",
  null
  
)

export default component.exports